import React, { Component } from 'react';
import language from '../../assets/languages/language';
import FD from '../RestAPI/fetchData';
import GD from '../RestAPI/getData';
import App_data from '../config/App_data';
/* eslint-disable*/

class OrderDiscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      readings: [],
      token: '',
      idname: '',
      ValidToken: false,
      selectedMenu: this.props.params.selectedMenu,
      orders_details: {
        order_data: {},
        amount: 0,
      },
      username: '',
      China_price: 6.55,
      Canadian_China_price: 5.22,
      canadian_price: 5.22,
      usd_canadian_price: 1.26,
    };

    // this.toggleAlert= this.toggleAlert.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  getChinaPrice = () => {
    GD.GetCallAPI('https://api.exchangeratesapi.io/latest?base=USD').then(resp => {
      // console.log("resunfnvd", resp);
      // console.log("dollar", resp.rates.CNY);
      this.setState({
        China_price: resp.rates.CNY,
      });
    });
    GD.GetCallAPI('https://api.exchangeratesapi.io/latest?base=CAD').then(resp => {
      // console.log("resunfnvd", resp);
      // console.log("canada", resp.rates.CNY);
      this.setState({
        Canadian_China_price: resp.rates.CNY,
      });
    });
  };
  componentDidMount() {
    // this.getChinaPrice();
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    this.getOrdersById(storage_session['idname'], storage_session['token']);
    this.props.params ? this.setState({ username: this.props.params.username }) : null;
  }

  getOrdersById = (idname, token) => {
    var data = {
      idname: idname,
      token: token,
      order_id: this.props.params.orderid,
    };
    FD.callAPI(App_data.backend_api + '/checkout_v1/getOrdersbyid', data).then(resp => {
      if (resp.success) {
        this.setState({
          orders_details: {
            order_data: resp.orders_val,
            amount: resp.amount,
          },
        });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };

  _orderHistory() {
    this.context.router.push({
      pathname: `/orderhistory/${localStorage.getItem('selectedmenu')}/${this.state.username}`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: localStorage.getItem('selectedmenu'),
        username: this.state.username,
      },
    });
  }

  render() {
    var domainApp = localStorage.getItem('domainApp');
    let plan_details =
      this.state.orders_details && Object.keys(this.state.orders_details.order_data).length > 0
        ? JSON.parse(this.state.orders_details.order_data).all_order_details
        : null;
    let data1 = '';
    if (plan_details && plan_details.length) {
      data1 = Object.keys(plan_details).map((item, index) => (
        <tbody key={index}>
          <tr className='package-heading'>
            <td width='60%'>
              {plan_details[index].exam_name + ' (' + plan_details[index].package_type + ') '}
            </td>
            {
              // domainApp === 'WORLD' ?
              <td width='20%'>
                {plan_details[index].type !== 'unlessUnlimited'
                  ? `$${plan_details[index].price}`
                  : null}
              </td>
              //  : (
              //   <td width='20%'>
              //     {plan_details[index].type !== 'unlessUnlimited'
              //       ? `¥${Math.ceil(
              //           Math.ceil(
              //             plan_details[index].price * this.state.China_price
              //           ) / 10
              //         ) *
              //           10 -
              //           1}`
              //       : null}
              //   </td>
              // )
            }

            {
              // domainApp === 'WORLD' ?
              <td width='20%'>
                {plan_details[index].type !== 'unlessUnlimited'
                  ? `$${
                      plan_details[index].percent_discount == 0
                        ? plan_details[index].percent_discount
                        : Math.ceil(
                            plan_details[index].price * plan_details[index].percent_discount,
                          ) / 100
                    }`
                  : null}
              </td>
              //  : (
              //   <td width='20%'>
              //     {plan_details[index].type !== 'unlessUnlimited'
              //       ? `¥${
              //           plan_details[index].percent_discount == 0
              //             ? plan_details[index].percent_discount
              //             : Math.ceil(
              //                 plan_details[index].price *
              //                   plan_details[index].percent_discount
              //               ) / 100
              //         }`
              //       : null}
              //   </td>
              // )
            }
          </tr>
          {plan_details[index].extras.map((extras, key) => {
            return (
              <tr key={key} className='extras-table'>
                <td width='60%'>{'- ' + extras.title}</td>
                {
                  // domainApp === 'WORLD' ?
                  <td width='20%'>${extras.price}</td>
                  // : (
                  //   <td width='20%'>
                  //     {Math.ceil(
                  //       Math.ceil(extras.price * this.state.China_price) / 10
                  //     ) *
                  //       10 -
                  //       1}
                  //   </td>
                  // )
                }
                <td width='20%' />
              </tr>
            );
          })}
        </tbody>
      ));
    }

    var tot_price = 0;
    if (plan_details && plan_details.length) {
      Object.keys(plan_details).map((item, index) => {
        if (plan_details[index].percent_discount == '') {
          tot_price +=
            // domainApp === 'WORLD'  ?
            tot_price += plan_details[index].price;
          // : Math.ceil(
          //     Math.ceil(
          //       plan_details[index].price * this.state.China_price
          //     ) / 10
          //   ) *
          //     10 -
          //   1;
        } else {
          tot_price +=
            // domainApp === 'WORLD'?
            plan_details[index].price -
            Number((plan_details[index].price * plan_details[index].percent_discount) / 100);
          // : Math.ceil(
          //   Math.ceil(
          //     plan_details[index].price -
          //     Number(
          //       (plan_details[index].price *
          //         plan_details[index].percent_discount) /
          //       100
          //     ) *
          //     this.state.China_price
          //   ) / 10
          // ) *
          // 10 -
          // 1;
        }
      });
    }
    let payment_details =
      this.state.orders_details && Object.keys(this.state.orders_details.order_data).length > 0
        ? JSON.parse(this.state.orders_details.order_data)
        : null;
    var totalAmount =
      this.state.orders_details && this.state.orders_details.amount
        ? this.state.orders_details.amount.toFixed(2)
        : 0;
    return (
      <div className='animated fadeIn'>
        <div className='row'>
          <div className='col-sm-12'>
            <div className='card margin_bottom_20'>
              <div className='card-header'>
                <div className='mb-1 d-inline-block'>{language.LC().Order_Details}</div>
                <div className='card-actions float-md-right'>
                  <button
                    type='button'
                    className='btn btn-primary pointer_class'
                    onClick={this._orderHistory.bind(this)}
                  >
                    {' '}
                    {language.LC().GO_TO_HISTORY}{' '}
                  </button>
                </div>
              </div>
              <div className='card-block'>
                <div className='row'>
                  <div className='col-md-7 margin_bottom_30'>
                    <div className='table_responsive_wrapper'>
                      <div className='table-responsive thankyou_tb'>
                        <table className='table cart_table '>
                          <thead>
                            <tr>
                              <th width='60%'>{language.LC().PACKAGE}</th>
                              <th width='20%'>{language.LC().PRICE}</th>
                              <th width='20%'>{language.LC().DISCOUNT}</th>
                            </tr>
                          </thead>
                          {data1}
                          <tfoot>
                            <tr className={this.state.cart_bottom}>
                              <td>
                                <strong>{language.LC().TOTAL}</strong>
                              </td>
                              {
                                // domainApp === 'WORLD' ?
                                <td>${totalAmount}</td>
                                // : (
                                //   <td>
                                //     ¥
                                //     {Math.ceil(
                                //       Math.ceil(
                                //         totalAmount *
                                //         this.state.Canadian_China_price
                                //       ) / 10
                                //     ) *
                                //       10 -
                                //       1}
                                //   </td>
                                // )
                              }
                              <td />
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-5'>
                    <div className='table-responsive thankyou_tb'>
                      {payment_details ? (
                        <table className='table cart_table'>
                          <tbody>
                            <tr>
                              <td>
                                <strong> {language.LC().ORDER_ID} :</strong>
                              </td>
                              <td>{payment_details.order_id}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>{language.LC().NAME}:</strong>
                              </td>
                              <td className='text-capitalize'>{payment_details.username}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>{language.LC().PAYMENT_METHOD} :</strong>
                              </td>
                              <td className='text-capitalize'>{payment_details.payment_type}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>{language.LC().EMAIL} :</strong>
                              </td>
                              <td>{payment_details.idname}</td>
                            </tr>
                          </tbody>
                        </table>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OrderDiscription;



// WEBPACK FOOTER //
// ./src/views/OrderDiscription/OrderDiscription.js